export default '84DE7';
